import $fetch from '@/services/client'
import type { LangCode } from '@/services/schemas'

async function productDetails(rNumber: string, language: LangCode) {
  const response = await $fetch('products/my-controller-details/:rnumber/:language/json', {
    params: {
      language,
      rnumber: rNumber,
    },
  })

  return response.data
}

export default productDetails
